import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Injectable, Injector} from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { LoggerService } from './logger.service';
import { map } from 'rxjs/operators';

const PATH_FILE = 'app/shared/jwtrefresh.interceptor.ts';

@Injectable()
export class JwtRefreshInterceptor implements HttpInterceptor {
	constructor(private readonly injector: Injector) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			map((event: HttpEvent<any>) => {
				if (event instanceof HttpResponse) {
					let authService = this.injector.get(AuthService);
					if (!event.url.startsWith(authService.REST_API_USERDATA)) { // Um eine Endlosschleife zu verhindern
						let _logger = this.injector.get(LoggerService);
						_logger.log(PATH_FILE + ' - intercept storeNewToken');
						authService.storeNewToken(event); // Das token mit dem vom Server neu gelieferten erneuern
					}
				}
				return event;
			})
		);
	}
}
